export const BFF_URL =
  process.env.REACT_APP_BFF_URL || "http://localhost:3000/bff/single-crm/v1";
export const BFF_HELP_CENTER_RESOURCE = `${BFF_URL}/help-center`;
export const BFF_ACCOUNT_ENDPOINT = `${BFF_HELP_CENTER_RESOURCE}/account`;
export const BFF_SALESFORCE_ACCOUNT_ENDPOINT = `${BFF_ACCOUNT_ENDPOINT}/salesforce`;
export const BFF_SUPPORT_TICKETS_LIST = `${BFF_HELP_CENTER_RESOURCE}/support-tickets/list`;
export const BFF_SUPPORT_TICKETS_NEW = `${BFF_HELP_CENTER_RESOURCE}/support-tickets/new-ticket`;
export const BFF_SUPPORT_USER_STATUS = `${BFF_HELP_CENTER_RESOURCE}/support-tickets/support-user-status`;
export const BFF_SUPPORT_GET_ATTACHMENT = `${BFF_HELP_CENTER_RESOURCE}/support-tickets/attachments/:id`;
export const SEND_MESSAGE = "/chat";
export const REACT_MESSAGE = "/chat/reaction/:chat_message_id";

export const BFF_SUPPORT_TICKETS_ENDPOINT = (
  ticketId: string | null = null
) => {
  const endpoint = `${BFF_HELP_CENTER_RESOURCE}/support-tickets`;

  if (ticketId) {
    return `${endpoint}/${ticketId}`;
  }

  return `${endpoint}`;
};
export const BFF_SUPPORT_TICKETS_COMMENT_ENDPOINT = (ticketId: string) =>
  `${BFF_SUPPORT_TICKETS_ENDPOINT()}/${ticketId}/comment`;
